/* ============================================================
   LUXE AESTHETICS — THEME JS
   ============================================================ */

(function () {
  'use strict';

  /* --- Mobile menu toggle ---------------------------------- */
  const menuToggle = document.getElementById('luxe-menu-toggle');
  const mobileNav  = document.getElementById('luxe-mobile-nav');

  if (menuToggle && mobileNav) {
    menuToggle.addEventListener('click', () => {
      const isOpen = mobileNav.classList.toggle('is-open');
      menuToggle.classList.toggle('is-open', isOpen);
      menuToggle.setAttribute('aria-expanded', String(isOpen));
      mobileNav.setAttribute('aria-hidden', String(!isOpen));
      document.body.style.overflow = isOpen ? 'hidden' : '';
    });

    document.addEventListener('click', (e) => {
      if (!menuToggle.contains(e.target) && !mobileNav.contains(e.target)) {
        mobileNav.classList.remove('is-open');
        menuToggle.classList.remove('is-open');
        menuToggle.setAttribute('aria-expanded', 'false');
        mobileNav.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
      }
    });
  }

  /* --- Scroll-reveal (Intersection Observer) -------------- */
  const revealEls = document.querySelectorAll(
    '.luxe-treatment-card, .luxe-pillar, .luxe-testimonial, .luxe-product-card, .luxe-stat, .luxe-meet-jay__content, .luxe-meet-jay__image-col'
  );

  if ('IntersectionObserver' in window && revealEls.length) {
    revealEls.forEach((el) => el.classList.add('reveal'));

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12 }
    );

    revealEls.forEach((el) => observer.observe(el));
  }

  /* --- Same-page anchor smooth scroll --------------------- */
  document.querySelectorAll('a[href*="#"]').forEach(function (link) {
    link.addEventListener('click', function (e) {
      const href = link.getAttribute('href');
      const hashIndex = href.indexOf('#');
      if (hashIndex === -1) return;
      const path = href.slice(0, hashIndex);
      const hash = href.slice(hashIndex + 1);
      if (!hash) return;
      const currentPath = window.location.pathname.replace(/\/$/, '');
      const linkPath = path.replace(/\/$/, '');
      if (linkPath === '' || linkPath === currentPath) {
        const target = document.getElementById(hash);
        if (target) {
          e.preventDefault();
          const headerEl = document.getElementById('luxe-header');
          const offset = headerEl ? headerEl.offsetHeight + 20 : 100;
          const top = target.getBoundingClientRect().top + window.scrollY - offset;
          window.scrollTo({ top: top, behavior: 'smooth' });
          if (mobileNav) {
            mobileNav.classList.remove('is-open');
            mobileNav.setAttribute('aria-hidden', 'true');
            document.body.style.overflow = '';
            if (menuToggle) {
              menuToggle.classList.remove('is-open');
              menuToggle.setAttribute('aria-expanded', 'false');
            }
          }
        }
      }
    });
  });

  /* --- Header scroll state --------------------------------- */
  const header = document.getElementById('luxe-header');
  if (header) {
    let lastY = 0;
    window.addEventListener('scroll', () => {
      const y = window.scrollY;
      if (y > 60) {
        header.style.background = 'rgba(17,17,17,0.98)';
      } else {
        header.style.background = 'rgba(28,28,28,0.95)';
      }
      lastY = y;
    }, { passive: true });
  }

})();